import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5fc1ab8e")

_pushScopeId("data-v-5fc1ab8e")
const _hoisted_1 = { id: "endpointList" }
const _hoisted_2 = { class: "checkbox" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "checkmark" }, null, -1)
const _hoisted_4 = { class: "label" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_GenericDialog = _resolveComponent("GenericDialog")

  return (_openBlock(), _createBlock(_component_GenericDialog, {
    header_text: "Endpunkte exportieren",
    max_width: "800px",
    buttons: ['Kopieren'],
    onClicked: _cache[2] || (_cache[2] = btn => _ctx.copyExportString()),
    onClose: _ctx.close
  }, {
    default: _withId(() => [
      _createVNode("div", _hoisted_1, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.endpoints, (endpoint, index) => {
          return (_openBlock(), _createBlock("div", {
            class: "endpointItem",
            key: endpoint[0].name
          }, [
            _createVNode("label", _hoisted_2, [
              _createVNode("input", {
                type: "checkbox",
                checked: "",
                onClick: ($event: any) => (_ctx.toggleChecked(index))
              }, null, 8, ["onClick"]),
              _hoisted_3,
              _createVNode("div", _hoisted_4, _toDisplayString(endpoint[0].name), 1)
            ])
          ]))
        }), 128))
      ])
    ]),
    footer: _withId(() => [
      _withDirectives(_createVNode("textarea", {
        id: "exportTextArea",
        readonly: "",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.exportString = $event)),
        rows: "4"
      }, null, 512), [
        [_vModelText, _ctx.exportString]
      ])
    ]),
    _: 1
  }, 8, ["onClose"]))
})